import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { projectsApi } from '../services/api';
import { Project } from '../types';
import PageMeta from '../components/PageMeta';
import '../styles/pages.css';
import '../styles/ProjectsSection.css';

const getCategoryLabel = (project: Project): string => {
  if (project.categoriaLabel) return project.categoriaLabel;
  const text = project.titulo.toLowerCase();
  if (text.includes('curso') || text.includes('capacita')) return 'Cursos de capacitação';
  if (text.includes('campo')) return 'Dia de campo';
  if (text.includes('social') || text.includes('ação')) return 'Ações sociais';
  return 'Projetos';
};

const getProjectImage = (project: Project): string => {
  if (project.galeriaFotos?.fotos?.length) {
    const main = project.galeriaFotos.fotos.find(f => f.isPrincipal) || project.galeriaFotos.fotos[0];
    return main.url;
  }
  return 'https://via.placeholder.com/600x400?text=Projeto';
};

const ProjectListing: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    projectsApi.getAll()
      .then(data => setProjects(
        data
          .filter(p => p.categoriaLabel !== 'Dia de campo')
          .sort((a, b) => new Date(b.dataProjeto).getTime() - new Date(a.dataProjeto).getTime())
      ))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-container">
      <PageMeta
        title="Projetos e Ações Sociais"
        description="Conheça os projetos e ações sociais da Agricampanha. Iniciativas que promovem o desenvolvimento sustentável e o fortalecimento dos produtores rurais da Campanha Gaúcha."
        url="/projetos"
      />
      {/* Topo padrão */}
      <div className="page-header">
        <div className="page-header-bg" style={{ backgroundImage: "url('/img/hero-image.jpg')" }} />
        <div className="page-header-overlay" />
        <Container className="page-header-content">
          <span className="section-badge section-badge--solid">O que acontece por aqui</span>
          <h1>Projetos e Ações Sociais</h1>
        </Container>
        <div className="page-header-fita" style={{ backgroundImage: "url('/img/bg-fita.png')" }} />
      </div>

      <Container className="page-content" style={{ paddingTop: '4rem' }}>
        {loading ? (
          <Row className="g-4">
            {[1,2,3,4,5,6].map(i => (
              <Col key={i} xs={12} sm={6} lg={4}>
                <div className="news-skeleton" style={{ height: 300 }}>
                  <div className="news-skeleton-image" style={{ height: 180 }} />
                  <div className="news-skeleton-content">
                    <div className="news-skeleton-line" />
                    <div className="news-skeleton-line short" />
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        ) : projects.length === 0 ? (
          <div className="text-center py-5">
            <i className="bi bi-folder" style={{ fontSize: '4rem', color: 'var(--color-gray)' }}></i>
            <p className="text-muted mt-3 fs-5">Nenhum projeto disponível no momento.</p>
          </div>
        ) : (
          <Row className="g-4 projects-row-5">
            {projects.map(project => (
              <Col key={project.id} xs={12}>
                <Link to={`/projetos/${project.slug}`} className="project-card-link">
                  <div className="project-card">
                    <div
                      className="project-img-wrapper"
                      style={{ backgroundImage: `url(${getProjectImage(project)})` }}
                      role="img"
                      aria-label={project.titulo}
                    >
                      <span className="project-card-category">{getCategoryLabel(project)}</span>
                    </div>
                    <div className="project-card-body">
                      <h3 className="project-card-title">{project.titulo}</h3>
                      <span className="project-read-more">
                        Saiba mais <span className="arrow">→</span>
                      </span>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default ProjectListing;
